<template>
	<v-container id="container" fluid class="fill-height">
		<v-row justify="center" align="center">
			<v-col cols="12">
				<font-awesome-icon
					v-if="!streamComponent"
					icon="sync"
					size="3x"
					spin>
				</font-awesome-icon>
				<component v-else :is="streamComponent"></component>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import {fetchStyleConfiguration} from "@/api/homepage.api";
import {componentForStyle, getStyleName} from "@/utils";

export default {
	name: "StreamPage",
	data() {
		return {
			streamComponent: null
		};
	},
	async beforeRouteEnter(to, from, next) {
		try {
			const styleResponse = await fetchStyleConfiguration(),
				component = componentForStyle(styleResponse.data.style);

			if (component === null) {
				throw Error("Component not found")
			}

			next(vm => {
				vm.streamComponent = component
			})
		} catch (e) {
			console.info("Using old style.")
			const styleResponse = await fetchStyleConfiguration(),
				styleName = getStyleName(styleResponse.data.style);

			import(`../components/pageStyles/${styleName}/css/main.scss`);
			next(vm => {
				vm.streamComponent = () =>
					import(`../components/pageStyles/${styleName}/Stream.vue`)
			})
		}
	},
};
</script>
